import React from 'react'
import { Col, Container, Row } from '@headtrip/components-react'
import { Breadcrumbs } from '../components/Navigation/Breadcrumbs/Breadcrumbs'
import CategoryList from '../components/ProductPage/CategoryList'
import ProductArticleList from '../components/ProductPage/ProductArticleList'
import { Tree, Product } from '../types/tree'

interface ProductProps {
  pageContext: Props
  location: Location
  data: QueryProps
  path: string
}

interface Props {
  product: Product
  panelSlug: string
  panelName: string | undefined
  productSlug: string
  tree: Tree
}

interface QueryProps {
  allMarkdownRemark: Edges
}

interface Edges {
  edges: Array<{ node: Node }>
}

const ProductPage = (props: ProductProps) => {
  const { pageContext, path } = props
  const { tree, panelSlug, productSlug } = pageContext
  const { panels } = tree
  const currentPanel = panels?.find(panel => panel.panelSlug === panelSlug)
  if (typeof currentPanel === 'undefined') return null
  const { products } = currentPanel
  const currentProduct = products?.find(product => product.productSlug === productSlug)
  if (typeof currentProduct === 'undefined') return null
  const {
    title,
    categories,
    panelName,
    productName,
    description,
    articles
  } = currentProduct as Product

  return (
    <section
      className='w-100'
    >
      <Container
        className={'py-5'}
      >
        <Row>
          <Col xl={{ span: 10, offset: 1 }} xs={12}>
            <Breadcrumbs
              className='mb-4'
              path={path}
              displayName={[panelName, productName]}
              collapseMobile={true}
            />

            <h4 className='text-transform-none'>{title}</h4>
            {
              description && (
                <p className='mb-4'>
                  {description}
                </p>
              )
            }
            <ProductArticleList articles={articles} />
            <CategoryList
              productSlug={productSlug}
              categories={categories}
            />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export { Head } from '../utils/head'

export default ProductPage
